import type { Step } from '@/types'
import { isFemale } from '../conditions'
import { sharedPregnancyStatusStep } from './commonQuestions'
import {
  validateAltura,
  validateIdade,
  validateNome,
  validatePeso,
  validateTextoLivre,
} from '../validators'

/** Shared base steps — appears for ALL objectives */
export const baseSteps: Step[] = [
  {
    id: 'welcome',
    type: 'message',
    content: 'Olá! Vamos começar.',
  },
  {
    id: 'name',
    type: 'input',
    inputKey: 'nome',
    content: 'Como você prefere ser chamado?',
    validate: validateNome,
  },
  {
    id: 'greeting',
    type: 'message',
    content: 'Prazer, {{nome}}!',
  },
  {
    id: 'age',
    type: 'input',
    inputKey: 'idade',
    content: 'Quantos anos você tem?',
    validate: validateIdade,
  },
  {
    id: 'height',
    type: 'input',
    inputKey: 'altura',
    content: 'Qual sua altura em metros? (exemplo: 1.75)',
    validate: validateAltura,
  },
  {
    id: 'weight',
    type: 'input',
    inputKey: 'peso',
    content: 'Qual seu peso em kg? (exemplo: 70)',
    validate: validatePeso,
  },
  {
    id: 'sex',
    type: 'choice',
    inputKey: 'sexo',
    content: 'Qual é o seu sexo biológico?',
    options: [
      { label: 'Masculino', value: 'masculino' },
      { label: 'Feminino', value: 'feminino' },
      { label: 'Prefiro não informar', value: 'nao_informado' },
    ],
  },
  {
    ...sharedPregnancyStatusStep,
    condition: isFemale,
  },
  {
    id: 'has_allergies',
    type: 'choice',
    inputKey: 'tem_alergias',
    content: 'Você tem alguma alergia ou contraindicação? (medicamentos, alimentos e etc)',
    options: [
      { label: 'Sim', value: 'sim' },
      { label: 'Não', value: 'nao' },
    ],
  },
  {
    id: 'allergies',
    type: 'input',
    inputKey: 'alergias',
    content: 'Conte pra gente quais são para personalizarmos seu protocolo.',
    condition: (ctx) => ctx.vars.tem_alergias === 'sim',
    validate: validateTextoLivre,
  },
  {
    id: 'uses_chronic_meds',
    type: 'choice',
    inputKey: 'usa_medicamento_cronico',
    content: 'Você já toma algum medicamento para doença crônica ou psiquiátrica?',
    options: [
      { label: 'Sim', value: 'sim' },
      { label: 'Não', value: 'nao' },
    ],
  },
  {
    id: 'drug_interaction',
    type: 'input',
    inputKey: 'interacao_medicamentosa',
    content: 'Qual medicamento você utiliza?',
    condition: (ctx) => ctx.vars.usa_medicamento_cronico === 'sim',
    validate: validateTextoLivre,
  },
]
